export const VALID_DATE_FORMATS = ['YYYY-MM-DD', 'MM/DD/YYYY'];
